import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { AdminInstance } from "../utils/adminClass";
import { AdminAppFeedbackCardComponent } from "./adminAppFeedbackCardComponent";

export const AdminAppFeedbackComponent = () => {
  const { feedback, isLoading } = useSelector((state: any) => state.admin);
  const [filteredFeedback, setFilteredFeedback] = useState<any[]>([]);
  const [feedbackTypeFilter, setFeedbackTypeFilter] = useState<string | null>("All");
  const [completedFilter, setCompletedFilter] = useState<string | null>("All");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedFeedback, setSelectedFeedback] = useState<any | null>(null);
  const [completedStatus, setCompletedStatus] = useState<boolean>(false);

  useEffect(() => {
    if (!feedback.length) {
      // fetch feedback
      AdminInstance.getAllMvpFeedback();
    }
  }, []);

  useEffect(() => {
    let filtered = feedback.filter((item: any) => {
      const matchesType = feedbackTypeFilter === "All" || item.feedbackType === feedbackTypeFilter;
      const matchesCompletion =
        completedFilter === "All" ||
        (completedFilter === "Completed" && item.completed === true) ||
        (completedFilter === "Not Completed" && !item.completed);

      return matchesType && matchesCompletion;
    });
    setFilteredFeedback(filtered);
    console.log("filteredFeedback:", filteredFeedback);
    console.log("feedback", feedback);
  }, [feedback, feedbackTypeFilter, completedFilter]);

  const handleCardClick = (feedbackItem: any) => {
    setSelectedFeedback(feedbackItem);
    setCompletedStatus(feedbackItem.completed || false);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleSaveChanges = async () => {
    if (!selectedFeedback) return;

    try {
      const updatedFeedback = await AdminInstance.handleFeedbackCompletionToggle(selectedFeedback.id, completedStatus);

      // console.log('updatedfeedback', updatedFeedback)

      // // Ensure you create a new array with updated items to trigger re-render
      // setFilteredFeedback(currentFeedback =>
      //     currentFeedback.map(item => {
      //         console.log('itemid', item.id, updatedFeedback.id)
      //         return item.id === updatedFeedback.id ? { ...item, completed: updatedFeedback.completed } : item
      //     }
      //     )
      // );

      // console.log('filteredFeedback:', filteredFeedback);

      setShowModal(false);
      setSelectedFeedback(null); //// Reset selected feedback
    } catch (error) {
      console.error("Error updating feedback status:", error);
    }
  };

  // handler to copy email text template to keyboard
  const handleCopyTemplateKeyboard = () => {
    //     const template = `Thank you for submitting a <venue/product/brand> request - <insert name>. They have been added the app, as a special thank you, we have added 100 seeds to your account and we would love to send you a shirt and some stickers. If you are interested, please send us your address along with your shirt size and choice of black or white.\n
    // As we are getting ready to come out of beta, there are going to be a bunch of cool things happening, please keep using the app and if you have any ideas to make the app better do not hesitate. Thanks for being a part of our community!\n
    // Cheers,
    // Lyla`;

    const getFeedbackReadable = () => {
      if (!selectedFeedback) {
        return null;
      }

      console.log("selectedFeedback", selectedFeedback);
      switch (selectedFeedback?.feedbackType?.toLowerCase() || "asdf") {
        case "request a venue":
          return "venue";
        case "request a brand":
          return "brand";
        case "request a product":
          return "product";
        case "report a bug":
          return "bug";
        case "ideas for app improvements":
          return "improvement";
        default:
          return "N/A";
      }
    };

    const res = getFeedbackReadable();

    console.log("res", res);

    // setup dynamic template that places the name and the type of feedback
    const template = `Thank you for submitting a ${getFeedbackReadable()} request - ${selectedFeedback.user.firstName || selectedFeedback.user.username}. They have been added the app, as a special thank you, we have added 100 seeds to your account and we would love to send you a shirt and some stickers. If you are interested, please send us your address along with your shirt size and choice of black or white.\n\nAs we are getting ready to come out of beta, there are going to be a bunch of cool things happening, please keep using the app and if you have any ideas to make the app better do not hesitate. Thanks for being a part of our community!\n\nCheers,\nLyla`;

    navigator.clipboard.writeText(template);
  };

  return (
    <Container className="py-4">
      <Row>
        <Col>
          <h3>App Feedback</h3>
          <Button
            onClick={handleCopyTemplateKeyboard}
            style={{
              marginTop: 10,
            }}
          >
            Copy Email Template
          </Button>
        </Col>
      </Row>
      <Row className="pt-3">
        <Col xs={12} md={4}>
          <Form.Select aria-label="Filter by Feedback Type" onChange={(e) => setFeedbackTypeFilter(e.target.value)}>
            <option value="All">All Types</option>
            <option value="Request a Venue">Request a Venue</option>
            <option value="Request a Brand">Request a Brand</option>
            <option value="Request a product">Request a Product</option>
            <option value="Report a bug">Report a Bug</option>
            <option value="Ideas for app improvements">Ideas for App Improvements</option>
          </Form.Select>
        </Col>
        <Col xs={12} md={4}>
          <Form.Select aria-label="Filter by Completion Status" onChange={(e) => setCompletedFilter(e.target.value)}>
            <option value="All">All Statuses</option>
            <option value="Completed">Completed</option>
            <option value="Not Completed">Not Completed</option>
          </Form.Select>
        </Col>
      </Row>
      {isLoading ? (
        <Row>
          <Col style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Col>
        </Row>
      ) : (
        <Row className="mt-3">
          {filteredFeedback.map((item, idx) => (
            <Col key={idx} xs={12} md={6} lg={4} className="my-2">
              <AdminAppFeedbackCardComponent feedbackItem={item} onClick={() => handleCardClick(item)} />
            </Col>
          ))}
        </Row>
      )}

      <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Feedback Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedFeedback && (
            <>
              <p>
                <strong>Username:</strong> {selectedFeedback.user.username}
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${selectedFeedback.user.email}`} target="_blank" style={{ textDecoration: "none" }}>
                  {selectedFeedback.user.email}
                </a>
              </p>

              <p>
                <strong>Feedback:</strong> {selectedFeedback.feedback}
              </p>
              <p>
                <strong>Type:</strong> {selectedFeedback.feedbackType || "N/A"}
              </p>
              <Form.Check
                type="checkbox"
                label="Completed"
                checked={completedStatus} // Use local state for checkbox
                onChange={(e) => setCompletedStatus(e.target.checked)} // Update local state
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* copy template */}
          <Button
            style={{
              position: "absolute",
              left: 10,
            }}
            onClick={handleCopyTemplateKeyboard}
          >
            Copy Email Template
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              // Logic to handle saving the feedback as completed
              handleSaveChanges();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
